import BoxedCustomControl from './BoxedCustomControl';

export default BoxedCustomControl;
